import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTransactionExportsTable } from '@Modal/hooks/transactionExports/useTransactionExportsTable';
import { useState, useEffect } from 'react';

export const TransactionExportsTitle: React.FC = () => {
  const { refetchTransactionExports } = useTransactionExportsTable();
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => {
        setCooldown(cooldown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  const handleRefresh = () => {
    if (cooldown === 0) {
      refetchTransactionExports();
      setCooldown(10);
    }
  };

  return (
    <AtLocator type="container" name="TransactionExportsTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        {/* <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3">Exports</Typography>
        </Stack> */}
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={handleRefresh}
          disabled={cooldown > 0}
          sx={{ ml: 2 }}
        >
          {cooldown > 0 ? `Refresh (${cooldown}s)` : 'Refresh'}
        </Button>
      </Stack>
    </AtLocator>
  );
};
